import snakeCaseKeys from 'snakecase-keys';

import { type PaginatedApi } from '@api/types';
import { getRequest } from '@helpers/api';

import type { ListGameChangerFilesPayload, ListGameChangerFile } from './types';

/** Get list of game changer transaction files */
export const getListGameChangerFiles: PaginatedApi<
  ListGameChangerFilesPayload,
  ListGameChangerFile
> = payload => {
  const { entityId, ...requestPayload } = payload;
  return getRequest(`vFile/gameChangerFile/list/${entityId}/`, snakeCaseKeys(requestPayload));
};
